export const getRgFrontendHost = () => process.env.VUE_APP_RG_FE_API_BASE_URL || ''

export const getSamlEntityId = () => process.env.VUE_APP_SAML_ENTITY_ID || 'rewards-genius'

export const getAchAccessKey = () => process.env.VUE_APP_ACH_ACCESS_KEY || ''
export const getAchProfileId = () => process.env.VUE_APP_ACH_PROFILE_ID || ''
export const getAchApiCreateUrl = () => process.env.VUE_APP_ACH_API_CREATE_URL || ''
export const getAchApiUpdateUrl = () => process.env.VUE_APP_ACH_API_UPDATE_URL || ''
export const getAchApiFundUrl = () => process.env.VUE_APP_ACH_API_FUND_URL || ''
